module.exports = __webpack_public_path__ + "static/media/lcs_txt.40ac4131.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/lcs_txt.png
// module id = 1795
// module chunks = 0 1